import Steps from '@/components/ui/Steps/Steps';
import cn from '@/utils/cn';

import ClientCardClaimPanel from '../components/ClientCardClaimPanel';
import DefendantInfo from '../components/DefendantInfo';
import FaqClaimPanel from '../components/FaqClaimPanel';
import TrialInfo from '../components/TrialInfo';
import YourCaseInfo from '../components/YourCaseInfo';
import { useLoginContext } from '../lib/login';
import { Transition } from '@headlessui/react';
import { useLingui } from '@lingui/react';
import dayjs from 'dayjs';

const Panel = ({ show }: { show: boolean }) => {
  const { i18n } = useLingui();
  const { data, handleLogout } = useLoginContext();

  const steps =
    data?.caseStatuses &&
    [
      ...data.caseStatuses.past.map((s) => ({
        ...s,
        active: true,
      })),
      ...data.caseStatuses.future.map((s) => ({
        ...s,
        active: false,
      })),
    ].reverse();

  const trial = data?.caseStatuses?.future[0];

  return (
    <Transition
      as={'div'}
      enter="transition-all ease-out duration-300 delay-300"
      enterFrom="opacity-0 translate-y-10"
      enterTo="opacity-100 translate-y-0"
      leave="transition-all ease-in duration-200"
      leaveFrom="opacity-100 translate-y-0 h-[1200px]"
      leaveTo="opacity-0 translate-y-10 h-[500px]"
      className={'w-full'}
      show={show}
      appear
      unmount={false}
    >
      <ClientCardClaimPanel className="mb-5 hidden lg:flex" />
      <section
        className={cn(
          'flex min-h-[50vh] w-full min-w-[300px] max-w-full flex-col gap-2.5 rounded-lg border-t-[6px] border-blue-600 bg-gray-100 px-3.5 py-4 xs:min-w-[440px] lg:w-[980px] lg:gap-y-[30px] lg:rounded-[10px] lg:p-10'
        )}
      >
        <div
          className={cn(
            'flex flex-col gap-5 pb-2.5 lg:grid lg:grid-cols-2 lg:gap-x-4 lg:gap-y-[30px] lg:pb-0'
          )}
        >
          {data?.caseInfo && <YourCaseInfo {...data?.caseInfo} />}
          {data?.defendantInfo && (
            <DefendantInfo
              name={data.defendantInfo.defendant}
              address={data.defendantInfo.address}
            />
          )}
        </div>
        {trial && <TrialInfo {...trial} />}
        {steps && (
          <Steps
            steps={steps}
            title={i18n.t('Aktualny status sprawy')}
            caption={i18n.t('Co dalej?')}
            className="rounded-md bg-gray-200 px-[14px] py-4 pt-8 sm:px-6"
            stepsInfo={
              <div className="body-small">
                {i18n.t('Stan statusu na')}{' '}
                {dayjs(data.loginTime).format('DD.MM.YYYY r. HH:mm')}.{' '}
                {i18n.t('Aby zaktualizować,')}{' '}
                <button
                  type="button"
                  onClick={handleLogout}
                  className="text-primary hover:underline"
                >
                  {i18n.t('zaloguj się')}
                </button>{' '}
                {i18n.t('ponownie.')}
              </div>
            }
          />
        )}
      </section>
      {data?.serviceId && (
        <FaqClaimPanel serviceId={data.serviceId} className="mt-5" />
      )}
    </Transition>
  );
};

export default Panel;
